import { createAction, props } from "@ngrx/store";
import { CreateAiAgent } from "src/app/common/models/ai-agents.model";

export const editAiAgent = createAction(
  "[AI Agents] Edit AI Agent",
  props<{
    payload: any;
    agentId: string;
    action?: string;
    languageName?: string;
  }>(),
);

export const editAiAgentSuccess = createAction(
  "[AI Agents] Edit AI Agent Success",
  props<{ response: CreateAiAgent; action?: string; languageName?: string }>(),
);

export const editAiAgentError = createAction(
  "[AI Agents] Edit AI Agent Error",
  props<{ error: string }>(),
);

export const clearEditAiAgent = createAction("[AI Agents] Clear Edit AI Agent");
